import { post } from '../service/request'

export const getTutorList = (
	page = 1,
	limit = 10,
	parksCode = '001001',
	typeName = '专业创业导师团'
) => {
	const params = {
		pageNum: page,
		pageSize: limit,
		parksCode,
		typeName,
	}
	return post('/expertInfo/list', params)
}

export const getTutorDetail = (id) => {
	return post('/expertInfo/detail', { id })
}
// 园区服务
export const getParkService = (parkType = 1, page = 1, limit = 10) => {
	let params = {
		parksCode: '001001',
	}
	let url = ''
	switch (parkType) {
		case 1:
			url = '/kxParkService/list'
			break
		case 2:
			params.pageNum = page
			params.pageSize = limit
			url = '/kxParkEnterprise/list'
			break
	}
	return post(url, params)
}
export const getParkServiceDetailById = (id = '') => {
	return post('/kxParkEnterprise/detail', { id })
}
